export default [{ //BC管理
        path: '/BC',
        component: () =>
            import ('@/components/page/BCManage/BCList'),
        meta: { title: 'BC.BCManage' },
    },
    { //BC详情
        path: '/BCDetail',
        component: () =>
            import ('@/components/page/BCManage/BCDetail'),
        meta: { title: 'BC.BCDetail' },
    },
]